import './Progetto.css';
import ProgettoNav from './ProgettoNav';

function Progetto3() {
    return (
        <div className='progetto-container'>
            <ProgettoNav prevPath='/progetto-donna' nextPath='/progetto-biblioteche' />
            <h1 className='progetto-title'>RELAZIONE PROGETTO</h1>
            <h2 className='progetto-subtitle'>"LOCALI STORICI DEL FRIULI VENEZIA GIULIA – UNA STORIA DA RACCONTARE"</h2>

            <h3>AMBITO PRIORITARIO</h3>
            <p>
                Il progetto "Locali storici del Friuli Venezia Giulia – Una storia da raccontare" ricade ed è
                stato sviluppato nell'ambio delle finalità statutarie dell'Associazione Settemotivi.
            </p>
            <p>
                Il progetto è nato dalla volontà di "raccontare la storia" di quell'esercizio che ha in "bella
                mostra" la targa oro o d'argento quale "Locale Storico del FVG".
            </p>
            <p>
                Dall'elenco redatto dalla Regione FVG sono stati individuati alcuni Comuni e relative attività
                commerciali ma, preso atto che non tutti i Comuni sono rappresentanti nella predetta lista e
                conseguentemente non vi sono locali storici indicati, è stata raccontata anche la storia di
                quelle attività che hanno qualcosa da far conoscere.
            </p>
            <p>Il progetto ha coinvolto i sottonotati locali:</p>

            <p>1 – Bar Nazionale – con sede a Codroipo - bar:</p>
            <ul className='progetto-indent'>
                <li>Anno di apertura 1912;</li>
                <li>Titolare Alberta Cinelli</li>
                <li>Da cinque generazioni è di proprietà sempre della stessa famiglia (in linea femminile).</li>
            </ul>
            <p>2 – Da Re – con sede a Sacile – negozio di abbigliamento:</p>
            <ul className='progetto-indent'>
                <li>Anno di apertura 1906;</li>
                <li>Titolari i F.lli Da Re.</li>
            </ul>
            <p>3 – Bar Agli Amici – con sede a Casarsa della Delizia – bar:</p>
            <ul className='progetto-indent'>
                <li>Anno di apertura 1927;</li>
                <li>Titolare Corrado Colussi;</li>
                <li>Bar Agli Amici di Casarsa, meglio conosciuto come "da Gigion".</li>
            </ul>
            <p>4 – Strumenti Musicali Borgna – con sede a Casarsa della Delizia – negozio strumenti musicali:</p>
            <ul className='progetto-indent'>
                <li>Anno di apertura 1865;</li>
                <li>Titolari Borgna Ruggero e Rusalen Sandro;</li>
            </ul>
            <p>5 – Antico Molino F.lli Persello – con sede a Colloredo di Monte Albano – molino:</p>
            <ul className='progetto-indent'>
                <li>Anno di aperura 1928;</li>
                <li>Titolari F.lli Persello.</li>
            </ul>
            <p>6 – Panificio Folador – con sede a Prata di Pordenone – panificio:</p>
            <ul className='progetto-indent'>
                <li>Anno di aperura 1968</li>
                <li>Titolare Antonio Follador</li>
            </ul>
            <p>7 – Antica Trattoria Suban – con sede a Trieste – trattoria:</p>
            <ul className='progetto-indent'>
                <li>Anno di apertura 1865;</li>
                <li>Titolare Federica Suban.</li>
            </ul>
            <p>8 – CalzaturifioDonda – con sede a Trieste – calzature:</p>
            <ul className='progetto-indent'>
                <li>Anno di apertura 1887;</li>
                <li>Titolare Massimo Donda.</li>
            </ul>
            <p>9 – Specogna Vignaioli in Rocca Bernarda – con sede a Corno di Rosazzo – azienda di vini:</p>
            <ul className='progetto-indent'>
                <li>Anno di apertura 1963;</li>
                <li>Titolare Cristian Specogna.</li>
            </ul>
            <p>10 – Panificio Da Marino – con sede a Prata di Pordenone – Panificio:</p>
            <ul className='progetto-indent'>
                <li>Anno di apertura 1930;</li>
                <li>Titolare Nando Marino.</li>
            </ul>
            <p>11 – Calzature Kosic – con sede a Gorizia – calzature:</p>
            <ul className='progetto-indent'>
                <li>Anno di apertura 1934:</li>
                <li>Titolari f.lli Kosic.'</li>
            </ul>
            <p>12 – Bosco Supermercato – con sede a Trieste – supermercato alimentari:</p>
            <ul className='progetto-indent'>
                <li>Anno di apertura 1880;</li>
                <li>Titolari f.lli Bosco.</li>
            </ul>
            <p>13 – Enoteca Bischoff – con sede a Trieste – vendita vini e liquori:</p>
            <ul className='progetto-indent'>
                <li>Anno di apertura 1777;</li>
                <li>Titolare Claudio Tombacco.</li>
            </ul>
            <p>14 – Ristorante Na Vida – con sede a Fontanafredda   ristorante:</p>
            <ul className='progetto-indent'>
                <li>Anno di apertura 1975;</li>
                <li>Titolari f.lli Moras'</li>
            </ul>
            <p>15 – Trattoria Cavour – con sede a Sacile – trattoria:</p>
            <ul className='progetto-indent'>
                <li>Anno di apertura 1963;</li>
                <li>Titolare s.lle Bravin.</li>
            </ul>
            <p>16 – Ristorane Fassina – con sede a Fontanafredda – ristorante:</p>
            <ul className='progetto-indent'>
                <li>Anno di apertura 1960;</li>
                <li>Titolare Enzo e Carla.'</li>
            </ul>

            <h3>Programmazione Radiofonica</h3>
            <p>Tutte le interviste sono state trasmesse in radio.</p>
            <p>Le stesse verranno riproposte in replica nei prossimi mesi per dare ancora risalto al progetto.</p>

            <h3>Durata del progetto</h3>
            <p>Il progetto è stato realizzato dal 1° ottobre 2023 al 31 maggio 2024.</p>

            <h3>Estensione territoriale</h3>
            <p>
                Il progetto ha coinvolto direttamente i comuni di Casarsa della Delizia, Codroipo, Colloredo
                di Monte Albano, Corno di Rosazzo, Fontanafredda, Gorizia, Prata di Pordenone, Sacile e Trieste.
            </p>

            <h3>Convenzioni e Partner</h3>
            <p>
                Nell'ambito del progetto sono state attive le convenzioni con i Comuni di Casarsa della Delizia,
                Fontanafredda e Prata di Pordenone.
            </p>
            <p>Nessun partner coinvolto nel progetto.</p>

            <h3>Volontari coinvolti</h3>
            <p>
                I volontari coinvolti nel progetto nel periodo 1° ottobre 2023 – 31 maggio 2024 sono in numero
                di 5, di cui tre per tutto il periodo ed altri per periodi diversi.
            </p>
            <ProgettoNav prevPath='/progetto-donna' nextPath='/progetto-biblioteche' />
        </div>
    );
}

export default Progetto3;
